import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
  accountId,
  focusAfterTimeout
} from '../../util';

import {
  FeedbackRef
} from '../../util/refs';

import { getIcon } from '../../util/icons';

class FeedbackModal extends Component{

  state = {
    feedback: '',
    submitting: false,
    submitted: false
  }

  componentWillReceiveProps(nextProps){
    if(nextProps.visible){
      focusAfterTimeout(this, 'feedbackInput');
    }
  }

  hide(){
    this.setState({
      feedback: '',
      submitting: false,
      submitted: false,
    });

    this.props.hide();
  }

  submitFeedback(){

    if(this.state.submitted){
      this.hide();
    }
    else{

      this.setState({
        submitting: true
      });

      FeedbackRef().add({
        accountId: accountId(),
        feedback: this.state.feedback
      }).then(() => {
        this.setState({
          submitting: false,
          submitted: true
        });
      });
    }
  }

  renderActions(){

    const buttonEnabled = this.state.feedback !== '' && !this.state.submitting;
    const buttonText = this.state.submitting ? 'SENDING...' : (this.state.submitted ? 'DONE' : 'SEND');

    return(
      <div className="modal-actions">
        <button disabled={!buttonEnabled} onClick={this.submitFeedback.bind(this)} className="button pink-button">{buttonText}</button>
      </div>
    )
  }

  render(){

    const { message, iconKey } = this.props;

    const { submitted } = this.state;

    if(!this.props.visible){
      return null;
    }

    return (
      <div className="modal">
        <div className="modal-container">
          <div className="close-icon" onClick={this.hide.bind(this)}>X</div>
          <div className="modal-content">
            <div className="message-icon">{getIcon(submitted ? 'face-happy' : 'chat')}</div>
              <div className="message">
              {!this.state.submitted &&
                <p>Enter your feedback for the Velocity team below...</p>
              }
              {!this.state.submitted &&
                <textarea
                  ref={input => { this.feedbackInput = input; }}
                  className="pink"
                  disabled={this.state.submitting}
                  placeholder={'What\'s on your mind?'}
                  value={this.state.feedback}
                  onChange={e => { this.setState({ feedback: e.target.value }) }}
                  ></textarea>
              }
              {this.state.submitted &&
                <p>Thanks for your feedback! If you need immediate assistance, reach out to us at <a className="pink" href="mailto:dev@velocity.win" target="_blank">dev@velocity.win</a>.</p>
              }
              {this.state.submitted &&
                <p style={{opacity: .5, fontSize: '16px'}}>{`Here's`} what you sent us:<br/>&ldquo;{this.state.feedback}&rdquo;</p>
              }
              </div>
          </div>
          {this.renderActions()}
        </div>
      </div>
    )
  }
}

export default FeedbackModal;



// WEBPACK FOOTER //
// ./src/components/modals/feedback.js